import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { Formik } from 'formik';
import ContentRequestForm from './content_request_form';
import { patch, get } from '../../utils/api';
import { handleError, handleSubmitError } from '../../utils/errors';
import GrapeFormat from '../../utils/formatters/formik-grape-formatter';
import Header from './header';
import ErrorNotice from '../forms/error_notice';

const ContentRequestFormWrapper = props => {
  const { children } = props;

  return (
    <article id="content-request-form">
      <Header>Edit a content request form</Header>
      {children}
    </article>
  )
};

ContentRequestFormWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

const EditContentRequestForm = props => {
  const { appData } = props;
  const { brandProfileId, contentRequestFormId } = JSON.parse(appData);
  const [isFetching, setIsFetching] = useState(true);
  const [mountError, setMountError] = useState(false);

  const [values, setValues] = useState({
    brandProfileId,
    contentRequestFormId,
    name: '',
    instructions: '',
    includeAudience: false,
    includePillar: false,
    file: null,
    questions: []
  });

  function getContentRequestForm(id) {
    get(`/api/v1/content_request_forms/${id}`)
      .then(data => {
        setValues({
          brandProfileId,
          contentRequestFormId: id,
          name: data.name,
          instructions: data.instructions,
          includeAudience: data.includeAudience,
          includePillar: data.includePillar,
          file: data.file,
          questions: data.questions || []
        });

        setIsFetching(false);
      })
      .catch(errorResponse => {
        handleError(errorResponse, () => setMountError(true));
      });
  }

  useEffect(() => {
    getContentRequestForm(contentRequestFormId);
  }, [contentRequestFormId]);

  if (mountError) {
    return (
      <ContentRequestFormWrapper>
        <ErrorNotice msg="There was an error fetching your content request form." />
      </ContentRequestFormWrapper>
    )
  }

  return (
    <ContentRequestFormWrapper>
      <Formik
        initialValues={{ ...values }}
        validationSchema={object().shape({
          name: string().required('Name is required')
        })}
        onSubmit={(formValues, actions) => {
          patch(
            `/api/v1/content_request_forms/${contentRequestFormId}`,
            JSON.stringify(GrapeFormat({ ...formValues }, ['questions']))
          )
            .then(() =>
              window.location.replace(`/publications/${brandProfileId}/content_request_forms`)
            )
            .catch(errorResponse => {
              handleSubmitError(
                errorResponse,
                actions,
                'There was an error saving your content request form.'
              );
            });
        }}
        render={innerProps => (
          <ContentRequestForm {...innerProps} streamingData={values} isFetching={isFetching} />
        )}
      />
    </ContentRequestFormWrapper>
  );
};

EditContentRequestForm.propTypes = {
  appData: PropTypes.string.isRequired
};

export default EditContentRequestForm;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_request_forms/edit_content_request.jsx